<template>
    <section id="contact-us" class="pt-md-5 pb-md-5 pt-3 pb-3 bg-gray" :class="$root.getSectionClass('#contact-us')">
        <div class="container">
            <h2>Contact Us</h2>

            <div class="row">
                <div class="col-md-6">
                    <figure class="pt-md-3 pb-3 mr-md-5">
                        <img src="../assets/contact-us.gif" alt="">
                    </figure>
                </div>
                <div class="col-md-6">
                    <contact-form />
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faPhone, faEnvelope } from '@fortawesome/free-solid-svg-icons';
    import ContactForm from './ContactForm.vue';

    library.add(faPhone, faEnvelope);

    export default {
        name: 'ContactUs',

        components: {
            ContactForm,
        },
    };
</script>

<style lang="scss">
    @import '../scss/variables';

    #contact-us {
        h2 {
            color: #393e46;
        }
        .contacts {
            figure {
                img {
                    max-width: 100px;
                }
            }
            p {
                font-weight: 300;
            }
            a {
                color: #e6e6e6;
                .svg-inline--fa {
                    color: $color_2;
                }
                &:hover {
                    .svg-inline--fa {
                        color: $color_1;
                    }
                }
            }
        }
        @media (min-width: 768px) {
            padding-bottom: 10rem;
        }
    }
</style>
